var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("x-grid", {
          ref: "grid",
          attrs: {
            id: "formList",
            rowId: _vm.rowId,
            url: _vm.url,
            columns: _vm.columns,
            "form-config": _vm.formConfig,
            "toolbar-config": _vm.toolbarConfig,
            "print-config": _vm.printConfig,
            "pager-config": _vm.pagerConfig,
            "checkbox-config": _vm.checkboxConfig,
            "export-config": _vm.exportConfig,
            cellClick: _vm.chooseRow,
            cellDbClick: _vm.updateRow,
          },
          on: { "toolbar-addData": _vm.addRow },
          scopedSlots: _vm._u(
            [
              {
                key: _vm.toolbarConfig.templatelSlots,
                fn: function () {
                  return [
                    _c("vxe-button", { on: { click: _vm.download } }, [
                      _vm._v("下载模板"),
                    ]),
                    _c(
                      "a-upload",
                      {
                        staticStyle: { margin: "0 0 0 3px" },
                        attrs: {
                          name: "file",
                          multiple: false,
                          accept: ".xlsx",
                          action: _vm.api.visitTask.IMPORT,
                          headers: { token: _vm.token },
                          showUploadList: false,
                        },
                        on: { change: _vm.handleFileChange },
                      },
                      [_c("vxe-button", [_vm._v("导入")])],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "vxe-button",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { size: "mini", status: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.updateRow({ row: row })
                          },
                        },
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "vxe-button",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteTask(row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ],
            null,
            true
          ),
        }),
        _c(
          "formModal",
          {
            attrs: {
              title: "大客户拜访任务",
              centered: "",
              footer: null,
              maskClosable: false,
              visible: _vm.editModalVisible,
              width: 800,
              closable: true,
            },
          },
          [
            _vm.editModalVisible
              ? _c("detailForm", {
                  ref: "detailForm",
                  attrs: { rowId: _vm.editRowId },
                  on: {
                    saved: function ($event) {
                      return _vm.closeEdit(true)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }